import axios from 'axios';

interface UpdateOrderType {
  app: string;
  organization_id: number;
  priority_id: number;
  asset_id: number;
  order_code_id: number;
  order_code: string;
  description: string;
  department_id: number;
  status_id: number;
  scheduled_start_date: Date;
  scheduled_end_date: Date;
  custom_txt_field5: string;
  actual_start_date: Date;
  actual_end_date: Date;
  site_details_1: string;
  creation_date: Date;
  created_by: number;
  pm_schedule_id: number;
  parent_order_id: number;
  long_description: string;
  timezoneOffset: number;
}

export const FetchNewMexRecordsOperations = (timezoneOffset : number, planId?: number) => {

  const headers = {
    'Content-Type': 'application/json',
  };

  if (planId) {
    return axios.get(process.env.REACT_APP_API_GLOBAL_URL + `mex-order/fetch-records/${timezoneOffset}?planId=${planId}`, {
      headers,
    });
  } else {
    return axios.get(process.env.REACT_APP_API_GLOBAL_URL + `mex-order/fetch-records/${timezoneOffset}`, {
      headers,
    });
  }
};

export const SyncFullOperations = (timezoneOffset : number) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.get(process.env.REACT_APP_API_GLOBAL_URL + `mex-order/sync-full?timezoneOffset=${timezoneOffset}`, {
    headers,
  });
};


export const SyncFromMex = (obj: UpdateOrderType, timezoneOffset : number) => {
  const headers = {
    'Content-Type': 'application/json',
  };

  return axios.put(process.env.REACT_APP_API_GLOBAL_URL + `mex-order/sync-from-mex?timezoneOffset=${timezoneOffset}`, obj, {headers
  });
};

export const EditMexOperations = (obj: UpdateOrderType) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(process.env.REACT_APP_API_GLOBAL_URL + `mex-order`, obj, {
    headers,
  });
};

export const EditMexListOperations = (obj: UpdateOrderType[],timezoneOffset : number) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(process.env.REACT_APP_API_GLOBAL_URL + `mex-order/update-list?timezoneOffset=${timezoneOffset}`, obj, {
    headers,
  });
};
